import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalHeaderService } from '../global-header.service';
import { ContextService } from '../context.service';
import { WhyOverview } from '../why-overview';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-why-overview',
  templateUrl: './why-overview.component.html',
  styleUrls: ['./why-overview.component.less']
})
export class WhyOverviewComponent implements OnInit, OnDestroy {
  
  private subscriptions = new Subscription();

  public model: WhyOverview;

  constructor(
    private route: ActivatedRoute,
    private contextService: ContextService,
    private headerService: GlobalHeaderService ) {
  }

  ngOnInit() {
    this.model = new WhyOverview();

    var subscription = this.route.paramMap.subscribe(params => {

      var itemsSubscription = this.contextService.getWhys().subscribe(data => {
        this.model.items = data;
        this.headerService.setHead(this.model);
      });
      
      this.subscriptions.add(itemsSubscription);
    });
    
    this.subscriptions.add(subscription);
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
